module.exports = __webpack_public_path__ + "assets/asset_offshorerig.49357778.svg";